import { render, staticRenderFns } from "./WebsiteIcon.vue?vue&type=template&id=0f66615a&scoped=true&"
import script from "./WebsiteIcon.vue?vue&type=script&lang=js&"
export * from "./WebsiteIcon.vue?vue&type=script&lang=js&"
import style0 from "./WebsiteIcon.vue?vue&type=style&index=0&id=0f66615a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f66615a",
  null
  
)

export default component.exports